import type { JSX } from 'react'
import { seasonColors } from './shared'

const tulipPath = (x: number, top: number) =>
  `M${x - 4} ${top}V${top + 4}Q${x - 4} ${top + 8} ${x} ${top + 8}` +
  `Q${x + 4} ${top + 8} ${x + 4} ${top + 4}V${top}` +
  `L${x + 2} ${top + 2.5}L${x} ${top}L${x - 2} ${top + 2.5}Z`

export function SpringRoofLoad(): JSX.Element {
  const { red, pink, orange, purple } = seasonColors
  const tulips: [number, number, string][] = [
    [150, 96, red],
    [163, 92, pink],
    [176, 97, orange],
    [189, 93, purple],
    [202, 96, red],
    [215, 91, pink],
    [228, 95, orange],
    [241, 92, purple],
    [254, 97, red],
  ]
  const leaves = [156, 195, 234].map(
    (x) => `M${x} 108C${x - 3} 103 ${x - 2} 99 ${x + 1} 97C${x + 2} 101 ${x + 2} 105 ${x} 108Z`
  )
  return (
    <g>
      <g fill={seasonColors.leaf}>
        {tulips.map(([x, top]) => (
          <rect key={x} x={x - 0.8} y={top + 6} width="1.6" height={102 - top} />
        ))}
        <path d={leaves.join('')} />
      </g>
      {tulips.map(([x, top, color]) => (
        <path key={x} fill={color} d={tulipPath(x, top)} />
      ))}
      <rect x="140" y="107" width="124" height="9.5" rx="1.5" fill={seasonColors.planter} />
      <rect x="138" y="106" width="128" height="3" rx="1.5" fill={seasonColors.planterRim} />
    </g>
  )
}
